namespace RioERP.Users {
    export interface OrderEmailRequest extends Serenity.ServiceRequest {
        subject?: string;
        description?: string;
        ids?: string;
    }
}
